

<!-- <div class="col-md-12 d-flex flex-column text-center align-items-center">
  <div class="col-md-8">
    <div class="module-icon-card rounded-3 bg-dark-50 text-center">
      @if (moduleIconType === 'SVG') {
        <span class="module-icon">
          <mat-icon svgIcon="{{ moduleIconTitle }}"></mat-icon>
        </span>
      }
      @if (moduleIconType === 'MATERIAL') {
        <span class="material-symbols-outlined module-icon">{{ moduleIconTitle }}</span>
      }
    </div>
  </div>
  <span class="module-title text-wrap text-uppercase fs-6 pt-2 fw-bold">
    {{ moduleTitle | translate }}
  </span>
</div> -->
<div class=" bg-blue-100 flex flex-col min-h-screen">
<div class="flex flex-col items-center justify-center text-center gap-0 mt-3">

  <!-- Logo -->
  <div class="flex items-center justify-center">
    <img
      src="./assets/images/rita_logo.png"
      alt="logo"
      class="w-[70px] h-[70px] rounded-full" />
  </div>

  <!-- Enhanced Nova Point Title -->
  <div class="erita-title-wrapper flex flex-col items-center">
    <h1 class="erita-title">
      <span class="title-main">NOVA POINT</span>
    </h1>
    <div class="title-glow-effect"></div>
    <div class="title-underline"></div>
  </div>



<div class="sb-menu-items">
  <mat-nav-list class="!px-2">
    @for (menu of menuData; track menu) {

    <!-- Without children -->
    @if (!menu.children) {
    @if (menu?.isHint) {
    <div class="col-md-12 my-4">
      <h6 class="mat-hint align-items-center d-flex">
        <span class="material-symbols-outlined pe-2 ">{{ moduleIconTitle
          }}</span>
        {{ menu?.name | translate }}
      </h6>
    </div>
    } @else {
    <a [routerLink]="menu.route"
      routerLinkActive="active-side-menu"
      class="menu-item !bg-[#0072BB] !my-1 !flex !flex-row !items-center py-[13px] px-2 rounded-r-xl gap-2">
      @if (menu.icon) {
      @if (menu.iconType == 'SVG') {
      <mat-icon [svgIcon]="menu.icon" class="me-1">
      </mat-icon>
      }
      @if (menu.iconType == 'MATERIAL') {
      <mat-icon class="menu-icon me-1">
        {{ menu.icon }}
      </mat-icon>
      }
      }
      <span class="menu-label text-white font-bold">{{ menu.name |
        translate }}</span>
    </a>
    }
    }

    <!-- above to work with -->

    <!-- With children -->
    @if (menu?.children) {
    <mat-accordion>
      <mat-expansion-panel
        class="mat-elevation-z0 my-2 menu-children  !bg-[#DBE7F6]"
        [expanded]="isActiveRoute(menu?.children)">
        <mat-expansion-panel-header
          class="!px-2 !bg-[#0072BB] !rounded-r-xl hover:!bg-[#FFC107] hover:!translate-x-[1px]">
          <mat-panel-title class="big-menu-items">
            @if (menu.icon) {
            @if (menu.iconType == 'SVG') {
            <mat-icon
              [svgIcon]="menu.icon"
              class="me-1 text-primary opacity-70 transition-all duration-300 group-hover:opacity-100">
            </mat-icon>
            }
            @if (menu.iconType == 'MATERIAL') {
            <mat-icon
              class="me-1 text-white text-[18px]">
              {{ menu.icon }}
            </mat-icon>
            }
            }
            @if (menu?.icon) {
            <span>&nbsp;</span>
            }
            <span class="menu-label text-white font-bold">
              {{ menu?.name | translate }}
            </span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        @for (menuItemChild of menu?.children; track menuItemChild; let i
        = $index) {
        <div class="py-1">
          <a
            [routerLink]="menuItemChild.route"
            class="transition text-white border-2 flex flex-row items-center bg-[#0072BB] py-2 px-2 rounded-r-xl hover:bg-[#FFC107] translate-x-[3px]"
            routerLinkActive="active-menu">
            @if (menuItemChild.iconType == 'MATERIAL') {
            <mat-icon class="menu-icon me-1">
              {{ menuItemChild.icon }}
            </mat-icon>
            }
            @if (menuItemChild?.icon) {
            <span>&nbsp;</span>
            }
            <span class="font-semibold">{{ menuItemChild.name | translate
              }}</span>
          </a>
        </div>
        }
      </mat-expansion-panel>
    </mat-accordion>
    }
    }
  </mat-nav-list>
</div>
</div>
